import { Box, Stack, Popover, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { ProfileIcon } from "../Icon";
import { globalTheme } from "../../styles";
import { UpdatePasswordDialogBox } from "../UpdatePasswordDialogBox/UpdatePasswordDialogBox";
import { useUpdatePassword } from "../../hooks/useUpdatePassword";
import KeyIcon from "@mui/icons-material/Key";

export const ProfilePopover = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [updatedPasswordData, setUpdatedPasswordData] = useState("");
  const [updatedPasswordEnable, setUpdatedPasswordEnable] = useState<boolean>(false);

  const handleProfileIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfilePopoverClose = () => {
    setAnchorEl(null);
  };

  const openProfilePopover = Boolean(anchorEl);
  const profilePopoverId = openProfilePopover ? "simple-popover" : undefined;

  const onLogout = () => {
    window.localStorage.clear();
    navigate("/login");
    window.location.reload();
  };

  const handleOnclickUpdatePasswordMenuItem = () => {
    setDialogOpen(true);
  };

  const menuItems = [
    {
      label: "Update Password",
      icon: <KeyIcon sx={{ color: globalTheme.primaryColor }} />,
      onClick: () => {
        handleOnclickUpdatePasswordMenuItem();
      },
    },
    {
      label: "Logout",
      icon: <LogoutIcon sx={{ color: globalTheme.primaryColor }} />,
      onClick: () => {
        onLogout();
      },
    },
  ];
  const handleCloseDialog = () => setDialogOpen(false);

  const { updatedPasswordLoading, errorUpdatedPassword, RefetchUpdatedPassword, updatedPasswordResponse } = useUpdatePassword({
    updatedPasswordData,
    enabled: updatedPasswordEnable,
  });

  //Integrated with Update password API
  const handlePasswordUpdate = (newPassword) => {
    setUpdatedPasswordData({ ...newPassword });
    setUpdatedPasswordEnable(true);
    setAnchorEl(null);
  };

  useEffect(() => {
    setUpdatedPasswordEnable(false);
  }, [updatedPasswordEnable]);

  return (
    <>
      <Box
        sx={{
          cursor: "pointer",
        }}
      >
        <Box onClick={(e) => handleProfileIconClick(e)}>
          <ProfileIcon fill={globalTheme.secondaryColor} />
        </Box>
        <Popover
          id={profilePopoverId}
          open={openProfilePopover}
          anchorEl={anchorEl}
          onClose={handleProfilePopoverClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Stack spacing={1} padding={0.5}>
            {menuItems.map((item, index) => (
              <Stack
                key={index}
                direction="row"
                spacing={2}
                alignItems="center"
                onClick={item.onClick}
                sx={{
                  cursor: "pointer",
                  padding: 1,
                  "&:hover": {
                    backgroundColor: globalTheme.background,
                  },
                }}
              >
                {item.icon}
                <Box
                  sx={{
                    color: globalTheme.primaryColor,
                  }}
                >
                  <Typography variant="body2">{item.label}</Typography>
                </Box>
              </Stack>
            ))}
          </Stack>
        </Popover>
      </Box>
      <Stack>
        <UpdatePasswordDialogBox open={isDialogOpen} onClose={handleCloseDialog} onSubmit={handlePasswordUpdate} />
      </Stack>
    </>
  );
};
